var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIssueMissing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#111",
    d: "M11 3a1 1 0 0 1 2 0v2a1 1 0 0 1-2 0V3zm0 16a1 1 0 0 1 2 0v2a1 1 0 0 1-2 0v-2zm-8-6a1 1 0 0 1 0-2h2a1 1 0 0 1 0 2H3zm16 0a1 1 0 0 1 0-2h2a1 1 0 0 1 0 2h-2zm-.707-8.705v-.002a1 1 0 0 1 1.414 1.414l-1.582 1.581a1 1 0 0 1-1.413-1.413l1.58-1.58h.001zM5.707 19.707a.997.997 0 0 1-1.718-.703.994.994 0 0 1 .304-.71l1.582-1.582a.997.997 0 0 1 1.718.703.994.994 0 0 1-.305.71l-1.58 1.581-.001.001zm-1.414-14a1 1 0 0 1 1.414-1.415l1.581 1.583a1 1 0 0 1-1.413 1.413l-1.582-1.58zm15.414 12.586a1 1 0 0 1-1.414 1.414l-1.581-1.582a1 1 0 0 1 1.414-1.413l1.58 1.58.001.001z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIssueMissing);
export default __webpack_public_path__ + "static/media/issue_missing.296182d1cd0847146b2c4cc8959829b7.svg";
export { ForwardRef as ReactComponent };